// extracted by mini-css-extract-plugin
export default {"alert_list":"DetailsAlerts_alert_list__6JllB","alerts_wrapper":"DetailsAlerts_alerts_wrapper__YtNaY"};